export default __webpack_public_path__ + "static/media/opensquarebg.88d0096d.jpg";